// utils/RouteWrapper.js
import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import PropTypes from "prop-types";

const RouteWrapper = ({ component: Component, ...rest }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();

  return (
    <Component
      {...rest}
      location={location}
      navigate={navigate}
      params={params}
    />
  );
};

export default RouteWrapper;

RouteWrapper.propTypes = {
  component: PropTypes.elementType,
};